<div class="container-fluid">
  <div class="row table-wrapper">
    <mat-card class="modern-table-card">
      <mat-card-header class="mat-card-header">
        <!-- <mat-form-field class="search-field">
        <mat-label>Search Invoices</mat-label>
        <input
          matInput
          [type]="'text'"
          (change)="searchInvoiceQuery($event)"
          />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field> -->
        @if (invoiceForm) {
          <div class="table-toolbar" [formGroup]="invoiceForm">
            <mat-card-title
              >Accounting - <span class="text-muted">Invoices</span>
            </mat-card-title>
            <mat-form-field>
              <mat-label>Date range</mat-label>
              <!-- Use matPrefix to position the image on the left side -->
              <span matPrefix (click)="openDatePicker()">
                <img
                  src="../../../assets/icons/shooting-schedule.png"
                  alt="Date Icon"
                  class="date-icon"
                />
              </span>
              <mat-date-range-input
                [rangePicker]="bookingPicker"
                [min]="minDate"
                [max]="maxDate"
                (click)="openDatePicker()"
              >
                <input
                  matStartDate
                  placeholder="Start date"
                  formControlName="startDate"
                />
                <input
                  matEndDate
                  placeholder="End date"
                  formControlName="endDate"
                  (dateChange)="onDateRangeChange()"
                  (keydown)="$event.preventDefault()"
                  (paste)="$event.preventDefault()"
                />
              </mat-date-range-input>
              <mat-date-range-picker #bookingPicker></mat-date-range-picker>
            </mat-form-field>
            <!-- TODO: UNcomment when Export functionality is finalized -->
            <!-- <button mat-icon-button (click)="exportData()" matTooltip="Export">
                  <img src="../../../assets/icons/export-svg.svg" alt="Export Icon" class="import-icon" />
                </button> -->
            <button
              mat-icon-button
              (click)="importData(selection)"
              matTooltip="Import"
            >
              <img
                src="../../../assets/icons/Import.png"
                alt="Import Icon"
                class="import-icon"
              />
            </button>
            <button mat-icon-button [matMenuTriggerFor]="columnMenu">
              <mat-icon>settings</mat-icon>
            </button>
            <div class="row">
              <mat-menu #columnMenu="matMenu">
                <div class="column-menu-content">
                  @for (col of columns; track col) {
                    @if (col.key !== "select" && col.isCheckbox !== true) {
                      <mat-checkbox
                        [checked]="visibleFieldKeys.includes(col.key)"
                        (change)="toggleColumnVisibility(col.key)"
                      >
                        {{ col.label }}
                      </mat-checkbox>
                    }
                  }
                </div>
              </mat-menu>
            </div>
          </div>
        }
      </mat-card-header>
      <mat-card-content class="table-layout-content">
        <div class="table-container-scroll mat-elevation-z2">
          <section class="example-container table-scroll-region" tabindex="0">
            <mat-table
              [dataSource]="sortedData"
              matSort
              (matSortChange)="handleSortChange($event)"
              class="custom-column-divider modern-table"
            >
              @for (col of columns; track col) {
                <ng-container [matColumnDef]="col.key">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    [sticky]="col.sticky"
                    class="table-header-cell"
                  >
                    @if (col.key === "select") {
                      <mat-checkbox
                        (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="
                          selection.hasValue() && !isAllSelected()
                        "
                        [aria-label]="checkboxLabel()"
                      >
                      </mat-checkbox>
                    }
                    @if (col.sortable) {
                      <span [mat-sort-header]="col.key">{{ col.label }}</span>
                    }
                    @if (!col.sortable) {
                      <span>{{ col.label }}</span>
                    }
                  </th>
                  <td mat-cell *matCellDef="let row" class="table-data-cell">
                    @if (col.key === "select") {
                      <mat-checkbox
                        (change)="selection.toggle(row)"
                        [checked]="selection.isSelected(row)"
                        [aria-label]="checkboxLabel(row)"
                      >
                      </mat-checkbox>
                    }
                    @if (col.key === "actions") {
                      <div class="actions-col">
                        <button mat-menu-item (click)="openInvoiceDetails(row)">
                          <img
                            src="../../../../assets/icons/view_icon.png"
                            width="20px"
                            alt="View details"
                            class="src"
                          />
                        </button>
                        <button mat-menu-item (click)="deleteInvoice(row)">
                          <img
                            src="../../../../assets/icons/delete_icon.png"
                            width="14px"
                            alt="Delete"
                            class="src"
                          />
                        </button>
                        <!-- <button mat-icon-button [matMenuTriggerFor]="accountActionsMenu" aria-label="deleteInvoice actions">
                                  <mat-icon>more_vert</mat-icon>
                                </button> -->
                      </div>
                    }
                    @if (col.key !== "select" && col.key !== "actions") {
                      <span>
                        @switch (col.key) {
                          @case ("role") {
                            <span>
                              @if (col.key === "role") {
                                <img
                                  src="../../../../assets/icons/klant.png"
                                  alt="Client"
                                  width="20"
                                />
                              } @else {
                                <img
                                  src="../../../../assets/icons/vakman.png"
                                  alt="Handyman"
                                  width="20"
                                />
                              }
                            </span>
                          }
                          @case ("importStatus") {
                            <span
                              class="table-data-text"
                              [ngClass]="{
                                'imported-status': row[col.key] === 'Imported',
                                'error-status':
                                  row[col.key] === 'Error' ||
                                  row[col.key] === 'Failed',
                                'default-status':
                                  row[col.key] !== 'Imported' &&
                                  row[col.key] !== 'Error' &&
                                  row[col.key] !== 'Open' &&
                                  row[col.key] !== 'Failed',
                              }"
                            >
                              @if (row[col.key] === "Imported") {
                                <img
                                  src="../../../../../assets/icons/Imported.png"
                                  alt=""
                                />
                              }
                              @if (row[col.key] === "Error") {
                                <img
                                  src="../../../../../assets/icons/Failed.png"
                                  alt=""
                                />
                              }
                              @if (row[col.key] === "Open") {
                                <img
                                  width="60"
                                  src="../../../../../assets/icons/Open.png"
                                  alt=""
                                />
                              }
                              @if (
                                row[col.key] !== "Imported" &&
                                row[col.key] !== "Error" &&
                                row[col.key] !== "Failed" &&
                                row[col.key] !== "Open"
                              ) {
                                {{ row[col.key] }}
                              }
                            </span>
                          }
                          @case ("importDate") {
                            <span>
                              {{
                                row[col.key] === "" ? "No Date" : row[col.key]
                              }}
                            </span>
                          }
                          @case ("profileName") {
                            <span>
                              {{
                                row[col.key] === "" ? "No Name" : row[col.key]
                              }}
                            </span>
                          }
                          @default {
                            <span>{{ row[col.key] }}</span>
                          }
                        }
                      </span>
                    }
                  </td>
                </ng-container>
              }

              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
                class="modern-table-header-row"
              ></tr>
              <!-- sticky: true -->
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                class="modern-table-data-row"
              ></tr>

              <tr class="mat-row no-data-row" *matNoDataRowDef>
                <td class="mat-cell" [attr.colspan]="columns.length">
                  No data matching the filter.
                </td>
              </tr>
            </mat-table>
          </section>
        </div>

        <app-pagination-table
          class="rounded-lg bg-white table-pagination-fixed"
          [totalResults]="totalRecords"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          [pageOffset]="pageOffset"
          (pageChange)="onPageChange($event)"
        >
        </app-pagination-table>
      </mat-card-content>
    </mat-card>
  </div>
</div>
